import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import type { ButtonProps } from '@components/main-components/button/Button';
import { Button } from '@components/main-components/button/Button';
import { DataTestId } from '@utils/test';
import { BellCheck } from '../BellCheck';

type IconButtonProps = {
  showSubscribed: boolean;
  onClick: ButtonProps['onClick'];
  className?: string;
  isOwner: boolean;
};

export const IconButton = ({
  showSubscribed,
  onClick,
  className = 'h-9 w-9 min-w-[2.25rem] min-h-[2.25rem] px-0',
  isOwner,
}: IconButtonProps) => {
  //dont show button is artist is the same as the logged in user
  if (isOwner) return null;

  return (
    <Button
      label=""
      testId={DataTestId.GET_NOTIFIED_BUTTON}
      leadingIcon={
        showSubscribed ? (
          <span className=" [&_svg]:h-5 ">
            <BellCheck />
          </span>
        ) : (
          <FontAwesomeIcon icon={faBell} fontSize={20} />
        )
      }
      onClick={onClick}
      variant="tertiary"
      size="squared"
      className={className}
      iconOnly
    />
  );
};
